module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4U9GS"))).then(() => module.bundle.root('iDabs'));